import React from "react";
import "./styles.scss";

export default ({ id, name, defaultChecked, onChange, disabled, text }) => (
  <label htmlFor={id} className="genre-checkbox mr-2 mr-md-3 mb-3">
    <input
      type="checkbox"
      id={id}
      value={text}
      className="d-none"
      defaultChecked={defaultChecked}
      name={name}
      onChange={onChange}
      disabled={disabled}
    />
    <div className="appearance text-center">
      <p className="text text-capitalize mb-0">{text}</p>
    </div>
  </label>
);
